import type { SearchResultItemStory } from '../../../atoms/searchResults.js'
import classes from './result-collection.module.css'
import { SearchStory, type SearchStoryProps } from './SearchStory.js'

type Props = {
  title: string
  results: SearchResultItemStory[]
  variant?: SearchStoryProps['variant']
  noResults?: string
  onCloseSearchDialog: () => void
  navigationDisabled?: boolean
  activeItemId?: string
}

export function ResultCollection(props: Props) {
  const { title, results, variant, noResults, onCloseSearchDialog, navigationDisabled, activeItemId } = props

  const showNoResults = results.length === 0 && !!noResults

  return (
    <>
      <h6 className={classes.title}>{title}</h6>

      {showNoResults && <p className={classes.noResults}>{noResults}</p>}

      <div className={classes.list}>
        {results.map(item => (
          <SearchStory
            active={activeItemId === item.id}
            item={item}
            key={item.id}
            navigationDisabled={navigationDisabled}
            onCloseSearchDialog={onCloseSearchDialog}
            variant={variant}
          />
        ))}
      </div>
    </>
  )
}
